import { useAmpliFeatureFlags } from '@tackle-io/tackle-auth-tools';

/**
 * Hook to evaluate access to AWS integration pages
 */
export const useAwsIntegrationAccess = () => {
  const { flags } = useAmpliFeatureFlags();
  return flags['cloud-connector-aws-integrations'] === 'on';
};
